/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Refund/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconExternalLink from 'DesignSystem/Svgs/TysiaIconExternalLink/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2InfoFilled from 'DesignSystem/Svgs/Tysiav2InfoFilled/index'
import Tysiav2LedgerFilterClaims from 'DesignSystem/Svgs/Tysiav2LedgerFilterClaims/index'
import Tysiav2PlusIcon from 'DesignSystem/Svgs/Tysiav2PlusIcon/index'
import Tysiav2ReturnIcon from 'DesignSystem/Svgs/Tysiav2ReturnIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Refund({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Transactions/Content/Content/Transaction/EntityType/Refund"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsGreen200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsGreen900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.900'
        })
let entryAmountValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'amount',
format: fromFormat.numberMoney,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsOrange800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.800'
        })
let dtColorsOrange200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.200'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let constantData = 'added on '
let entrySysCreatedValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'sys_created',
format: fromFormat.dateShortWithMonth,
})
let constantData1 = '.'
let aggregateData = fromAggregate.joinNoSpace(constantData, entrySysCreatedValueData, constantData1)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let entryRefundRefundTypeValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'refund.refund_type',
format: fromFormat.toCapitalisedCamelCase,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Refund.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Refund.Vertical"
  data-view-path={viewPath}
 style={{'--btlr-1-Z2bFCzV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-2-Z2bFCzV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-3-Z2bFCzV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-4-Z2bFCzV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-Z2bFCzV': dtColorsGreen200,'--mt-6-Z2bFCzV': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2PlusIcon
  viewPath={`${viewPath}/Tysiav2PlusIcon`}
 fill2={dtColorsGreen900}
 width={6}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 weight="medium"
 data="entry.amount"
 format="/Data/format.js numberMoney"
 text={entryAmountValueData}
/>
<div
  data-testid="Refund.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-7-Z2bFCzV': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-8-Z2bFCzV': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Refund.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="orange"
 style="filled"
 marginTop={dtSpaceXxxs}
>
{childProps => (
<React.Fragment>
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
>
{childProps => (
<Tysiav2LedgerFilterClaims
{...childProps}
  viewPath={`${viewPath}/Tysiav2LedgerFilterClaims`}
 fill={dtColorsOrange800}
 stroke={dtColorsOrange200}
 width={12}
 height={12}
/>
)}
</TysiaTagIcon>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Refund"
/>
</React.Fragment>
)}
</TysiaTag>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 marginLeft={dtSpaceXxxs}
 marginTop={3}
 height="auto"
 paddingLeft={0}
 paddingRight={0}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconExternalLink
{...childProps}
  viewPath={`${viewPath}/TysiaIconExternalLink`}
 fill={dtColorsWhite}
 width={13}
 height={13}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 data="'added on '"
 data="entry.sys_created"
 format="/Data/format.js dateShortWithMonth"
 data="'.'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="bottom"
 offsetMainAxis={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 marginLeft={dtSpaceXxxs}
 marginTop={3}
 height="auto"
 paddingLeft={0}
 paddingRight={0}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2InfoFilled
{...childProps}
  viewPath={`${viewPath}/Tysiav2InfoFilled`}
 width={13}
 height={13}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
</div>
<div
  data-testid="Refund.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-8-Z2bFCzV': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Tysiav2ReturnIcon
  viewPath={`${viewPath}/Tysiav2ReturnIcon`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 size="small"
 data="entry.refund.refund_type"
 format="/Data/format.js toCapitalisedCamelCase"
 text={entryRefundRefundTypeValueData}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}